<template>
  <div class="coursecontainer">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 教程内页 -->
    <div class="main-wrapper-content courseDetail">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/course' }">教程区</el-breadcrumb-item>
          <el-breadcrumb-item>{{ des.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="course-body">
        <div class="left">
          <div class="course-banner">
            <video-player class="video-player" @play="playReady()" style="width:100%;" ref="videoPlayer"
              :playsinline="true" :options="playerOptions">
            </video-player>
          </div>
          <div class="lan-des opensdet-intro-des clearfix">
            <div class="title">
              <h1 class="opensdet-intro-title ">{{ des.title }}</h1>
            </div>
            <div class="details-tags">
              <a href="javascript:void(0);" v-if="des.type == 4">教程</a>
              <a href="javascript:void(0);" v-if="des.type == 5">名师小灶</a>
            </div>
            <div class="sale-prices  free ">
              <p class="sale-prices-original">{{ des.introduction }}</p>
            </div>
            <div class="price" v-if="des.type == 5&&des.discount_price>0">
              ¥ {{des.discount_price}}
            </div>
          </div>
          <div class="download" v-show="des.is_role == 1&&downloadUrl">
            <img src="../assets/download.jpg" width="100%" />
            <a :href="downloadUrl" target="_balank">点击下载</a>
          </div>
          <div class="course-details-wrap_width">
            <div class="course-left_area">
              <div class="the-tabs">
                <ul class="heads">
                  <li class="active">课程详情 </li>
                </ul>
              </div>
              <div class="description">
                <div class="course_content_box">
                  <p v-html="des.content"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title_thumb_box">
            <div class="tides">
              <img :src="des.teacher.thumb" alt=""
                style="width:42px;height:42px;border-radius:100px;margin-right:5px;" />
              <span>{{ des.teacher.name }}</span>
            </div>
            <button class="guanzu">关注</button>
          </div>
          <div class="mulu">
            <p class="mu_title">　课程目录<span class="count"></span></p>
            <div class="menu-list">
              <ul>
                <li v-for="(item,i) in des.chapter" @click="showVideo(i)" :key="i" :class="playIng == i?'ing':''">
                  <p class="free">{{(i+1)<10?`0${i+1}`:(i+1)}}：{{item.title}}<img src="../assets/playing.gif"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="course-right_area">
            <div class="label">
              <div class="label-line"></div>
              <div class="label-tit">猜你想学</div>
            </div>
            <div class="course-recommendation_wrap">
              <div class="course-list" v-for="(item, i) in tuijData" :key="i" @click="toDetails(item.id)">
                <div class="img-box">
                  <img :src="item.thumb" />
                </div>
                <div class="list_right">
                  <div class="right__top">
                    <div class="title">{{ item.name }}</div>
                    <p class="price">
                      <span>￥</span>
                      {{ item.discount_price }}
                    </p>
                  </div>
                  <div class="study_num">
                    <span>{{ item.study_num == null ? "0" : item.study_num }}</span>
                    位同学在学
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'home',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        download: false,
        downloadUrl: '',
        activeName: 'first',
        des: {
          title: "",
          chapter: []
        },
        tuijData: [],
        playerOptions: {
          fluid: true,
          poster: ''
        },
        playIng: -1,
        userInfo: {}
      }
    },
    created() {
      if (this.$cookieStore.getCookie('userInfo')) {
        this.userInfo = JSON.parse(this.$cookieStore.getCookie('userInfo'))
      }
      this.getInfo()
    },
    methods: {
      playReady() {
        if (this.des.is_role != 1) {
          this.$message({
            message: '暂无权限观看，快去联系班主任老师吧！',
            type: 'error'
          });
          this.$refs.videoPlayer.player.pause(); // 暂停
          return false;
        }
      },
      showVideo(index) {
        if (this.des.is_role != 1) {
          this.$message({
            message: '暂无权限观看，快去联系班主任老师吧！',
            type: 'error'
          });
          return;
        }
        this.playIng = index;
        this.playerOptions = {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 如果为true,浏览器准备好时开始回放
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 是否视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "video/mp4", // 类型
            src: this.des.chapter[index].video // url地址
          }],
          poster: '', // 封面地址
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: true, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            fullscreenToggle: true // 是否显示全屏按钮
          }
        }
      },
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/TutorialDetail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.des = res.data.data
          this.downloadUrl = res.data.data.chapter[0].files; // 素材下载
          this.download = true;
          this.playerOptions = {
            playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
            autoplay: false, // 如果为true,浏览器准备好时开始回放
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 是否视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [{
              type: "video/mp4", // 类型
              src: res.data.data.chapter[0].video // url地址
            }],
            poster: '', // 封面地址
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: true, // 显示持续时间
              remainingTimeDisplay: false, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
            }
          }
        }).catch(err => {

        })
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/RecommendCourse', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            "limit": 4,
            "page": 1
          }
        }).then(res => {
          let data = res.data.data.data
          this.tuijData = data
        }).catch(err => {
          console.log(err)
        })
      },
      toDetails(id) {
        this.$router.push({
          path: "/CourseDetails",
          query: {
            id: id
          }
        })
        this.getInfo()
      },
    },
  }
</script>

<style lang="scss" scoped>
  // 素材下载
  .download {
    position: relative;
    img {
      position: relative;
    }
    a {
      display: block;
      position: absolute;
      right: 50px;
      top: 25px;
      width: 120px;
      text-align: center;
      background: #FABE00;
      color: white;
      height: 35px;
      border-radius: 20px;
      line-height: 35px;
    }
  }

  .course_content_box {
    overflow: hidden;
  }

  /deep/.course_content_box img {
    max-width: 850px !important;
    width: 100% !important;
  }

  .mulu img {
    display: none;
    width: 40px;
    float: right;
  }

  .ing img {
    display: block;
  }

  .courseDetail {
    .course-body {
      .right {
        .title_thumb_box {
          background-color: rgb(246, 248, 250);
          padding: 20px 10px;
          border-radius: 14px;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .guanzu {
            width: 60px;
            height: 28px;
            background: #D4EAFC;
            border-radius: 14px;
            font-size: 12px;
            color: #027CDB;
            text-align: center;
            line-height: 28px;
            border: none;
            cursor: pointer;
          }
        }

        .mulu {
          background-color: rgb(246, 248, 250);
          padding: 20px 10px;
          border-radius: 14px;
          text-align: left;

          .mu_title {
            font-size: 16px;
            color: #212B34;
            font-weight: 500;

            .count {
              float: right;
              color: #87959F;
              font-size: 12px;
              height: 22px;
              display: inline-block;
              line-height: 22px;
            }
          }

          .menu-list {
            max-height: 471px;
            overflow-y: auto;
            min-height: 132px;

            ul li {
              height: 33px;
              position: relative;
              line-height: 33px;
              padding-left: 16px;
              cursor: pointer;
              margin-bottom: 4px;
              border-radius: 6px;
              -webkit-border-radius: 6px;
              -moz-border-radius: 6px;
              -ms-border-radius: 6px;
              -o-border-radius: 6px;
              margin-top: 5px;

              &:hover {
                background: #FFFFFF;
              }
            }

            .live-anim {
              position: absolute;
              top: 3px;
              left: 16px;
              height: 30px;
              line-height: 19px;
              vertical-align: middle;
            }

            .live-anim {
              margin-right: 5px;
              display: inline-block;
              height: 40px;
              line-height: 28px;
            }

            .hide {
              display: none !important;
            }

            ul li p {
              display: inline-block;
              width: 255px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: middle;
              cursor: pointer;
            }

            dl,
            ol,
            ul {
              list-style: none;
            }

            dd,
            dl,
            li,
            ol,
            td,
            th,
            ul {
              padding: 0;
              margin: 0;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .video-js .vjs-big-play-button {
    top: 45%;
    left: 45%;
  }

  .opensdet-intro-des {
    border-bottom: 1px solid #F1F3F5;
    border-radius: 1px;
    padding-bottom: 25px;
  }

  .lan-des {
    position: relative;
    display: table-cell;
    width: 864px;
    text-align: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .opensdet-intro-des .title {
    padding: 20px 0 0 0;
  }

  .opensdet-intro-des .opensdet-intro-title {
    display: inline-block;
    margin: unset;
    color: #212B34;
    font-weight: 500;
    vertical-align: middle;
    width: 750px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .opensdet-intro-des .price {
    font-size: 25px;
    color: #FABE00;
  }

  .opensdet-intro-title {
    font-size: 20px;
    font-weight: 400;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .opensdet-intro-title {
    height: 24px;
    margin-top: 20px;
    margin-bottom: 16px;
    overflow: hidden;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3333333;
    color: #0f233a;
    cursor: default;
  }

  .opensdet-intro-des .title .right {
    font-size: 12px;
    color: #666666;
    float: right;
    height: 24px;
    align-items: center;
  }

  .opensdet-intro-des .title .right>span {
    margin-left: 32px;
    cursor: pointer;
    display: inline-block;
    height: 100%;
    line-height: 24px;
    vertical-align: top;
  }

  .opensdet-intro-des .title .right>span .icon-collected {
    background: url(https://assets-cdn.lanqb.com/lanqb/pc/vcourse-collection_1.png);
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 6px;
  }

  .opensdet-intro-des .title .right .icon-collected {
    transform: translateY(-2px);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
  }

  .opensdet-intro-des .title .right .icon {
    font-size: 20px;
    color: #B1B5B9;
    vertical-align: middle;
    display: inline-block;
  }

  .iconfont,
  .iconfont-2021 {
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .iconfont {
    font-family: iconfontL !important;
  }

  address,
  cite,
  dfn,
  em,
  i {
    font-style: normal;
  }

  .opensdet-intro-des .title .right>span {
    margin-left: 32px;
    cursor: pointer;
    display: inline-block;
    height: 100%;
    line-height: 24px;
    vertical-align: top;
  }

  .opensdet-intro-des .title .right>span .icon-share {
    background: url(https://assets-cdn.lanqb.com/lanqb/pc/vcourse-share.png);
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 6px;
  }

  .opensdet-intro-des .title .right .icon-share {
    font-size: 28px;
    position: relative;
  }

  .opensdet-intro-des .title .right .icon {
    font-size: 20px;
    color: #B1B5B9;
    vertical-align: middle;
    display: inline-block;
  }

  .iconfont,
  .iconfont-2021 {
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .opensdet-intro-des .title .right .share .vcourse-detail-share {
    display: none;
  }

  .vcourse-detail-share {
    padding-top: 20px;
  }

  .vcourse-detail-share {
    position: absolute;
    right: -32px;
    top: 37px;
    z-index: 2;
  }

  .vcourse-detail-share .inner {
    background: #FFFFFF;
    box-shadow: 0px 5px 15px 0px rgb(30 25 38 / 20%);
    border-radius: 6px;
    padding: 40px 32px;
    color: #525A67;
    font-size: 12px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    border: 1px solid #EFEFEF;
    height: 215px;
  }

  .vcourse-detail-share .left {
    display: inline-block;
    padding-right: 20px;
  }

  .details-tags {
    white-space: normal;
  }

  .details-tags {
    color: #B1B5B9;
  }

  .details-tags {
    min-height: 24px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top:5px;
  }

  .sale-prices {
    line-height: 25px;
    margin-top: 26px;
  }

  .details-tags>a:first-child {
    margin-left: 0;
  }

  .details-tags>a {
    margin-right: 16px;
    margin-top: 10px;
    margin-left: 0;
    background:#F6F8FA;
    padding:1px 5px;
  }

  .details-c1 .details-tags>a {
    height: 25px;
    line-height: 25px;
    background-color: #F6F8FA;
    border-radius: 6px;
    text-align: center;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    padding: 0 10px;
  }

  .details-tags>a,
  .details-tags>em {
    margin-right: 8px;
    margin-top: 5px;
    margin-left: 0;
  }

  .details-tags>a,
  .details-tags>em {
    margin-right: 4px;
    margin-top: 3px;
    margin-left: 0;
  }

  .details-tags>a {
    color: #B1B5B9;
  }

  .details-tags>a,
  .details-tags>em {
    margin-left: 4px;
  }

  .sale-prices .btns {
    display: inline-block;
    float: right;
  }


  .sale-prices>h4,
  .sale-prices>h5 {
    padding-right: 16px;
    border: none;
    position: relative;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
  }

  .sale-prices>h5.sale-prices-original>span {
    text-decoration: line-through;
  }

  .sale-prices>h5>span {
    padding-right: 0;
  }

  .sale-prices>h5>span {
    padding-right: 4px;
    font-family: arial;
  }

  .sale-prices .btns .opensdet-intro-btnd {
    display: inline-block;
    vertical-align: middle;
  }

  .opensdet-intro-btnd .opensdet-intro-btn {
    position: relative;
  }

  .opensdet-intro-btnd .free-buy-btn,
  .opensdet-intro-btnd .mqcc {
    background: linear-gradient(90deg, #26C6FD 0%, #2E9EF5 100%);
    transition: initial;
    color: #ffffff;
  }

  .opensdet-intro-btnd .opensdet-intro-btn {
    width: unset;
    height: 40px;
    line-height: 38px;
    border-radius: 40px;
    padding: 10px 26px;
  }

  .sale-prices .btns {
    display: inline-block;
    float: right;
  }

  .sale-prices .btns .sale-prices-num {
    color: #87959F;
    margin-right: 14px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
  }

  .details-tags>a,
  .details-tags>em {
    margin-left: 8px;
  }

  .details-tags>a,
  .details-tags>em {
    display: inline-block;
    font-size: 12px;
    line-height: 2;
    color: #87959f;
    vertical-align: middle;
  }

  a {
    cursor: pointer;
  }

  .courseDetail {
    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .course-details-wrap_width {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0 30px 0;
  }

  .course-right_area {
    margin-left: 15px;
    box-sizing: border-box;
    width: 335px;
    background-color: #fff;
    border-radius: 8px;

  }

  .course-left_area {
    width: 850px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px 0px 18px 0px;
    margin-bottom: 0px;
  }

  .course-recommendation_wrap {
    padding: 0;
    margin: 0;
  }

  .course-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .list_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: space-between;
  }

  .study_num {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a3a8ab;
  }

  .right__top {
    margin: 0;
  }

  .right__top .title {
    width: 144px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    color: #18252c;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .right__top .price {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff2b26;
    line-height: 20px;
  }

  .img-box {
    width: 145px;
    height: 80px;
    margin-right: 10px;
    overflow: hidden;
  }

  .img-box img {
    width: 100%;
    height: 100%;
    border-radius: 7px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .label {
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 0;
  }

  .label-tit {
    position: relative;
    text-align: left;
    padding-left: 16px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
  }

  .label-line {
    width: 6px;
    height: 18px;
    background-color: #FABE00;
  }

  .the-tabs {
    border: 0;
  }

  .description {
    margin-top: 25px;
  }

  .description img {
    display: block;
  }

  .heads {
    display: flex;
  }

  .course-details-wrap_width .course-left_area .the-tabs .heads li {
    min-width: 72px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #747c80;
    line-height: 25px;
    cursor: pointer;
    z-index: 10;
    text-align: center;
  }

  .active {
    font-weight: 600;
    color: #18252c !important;
    border-bottom: 4px solid #00d753;
  }

  .content_top {
    padding: 40px 0 10px 0;
  }

  .course-body {
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    border-radius: 8px;
    padding-bottom: 0;
    padding-left: 0;
  }

  .course-body .left {
    width: 850px;
    margin-right: 20px;
  }

  .course-body .left .course-banner {
    width: 850px !important;
    height: 500px !important;
  }

  .course-body .right {
    flex: 1;
    box-sizing: border-box;
    position: relative;
  }



  .wrap__bottom .price-tag {
    font-size: 18px;
  }

  .wrap__bottom .course-handle {
    width: 295px;
    height: 56px;
    font-size: 19px;
    line-height: 56px;
    text-align: center;
    background: linear-gradient(270deg, #ff4d40, #ff7e75);
    border-radius: 8px;
    cursor: pointer;
  }

  .wrap__bottom .course-handle span {
    font-size: 19px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 26px;
  }

  .course-body .right .course-info_wra .course-data {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 6px;
    padding: 14px 0 24px 0;
  }

  .course-body .right .course-info_wrap .wrap__top h3 {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 600px;
    text-align: left;
  }

  .course-body .right .course-desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
  }

  .course-body .right .course-data {
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 6px;
    padding: 14px 0 24px 0;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #d1d3d5;
    vertical-align: top;
    margin: 0 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails.vue